var scope_0 = require('/workspace/apps/marketing-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2b2bf4c4a6ac4f47942af2dc5e76f85f.js').default;
var scope_1 = require('/workspace/apps/marketing-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/895de1e3ba2e6c4ce55651e557babc19.js').default;
var scope_2 = require('/workspace/apps/marketing-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/99471efb38224280fbd0491d70db58d4.js').default;
var scope_3 = require('/workspace/apps/marketing-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    